import {CHVAE_TOKEN } from '@/global';

export default class WebSocketPushSyncManager {
  constructor() {
    this.ws = null;
    this.idSessaoAdmin = null;
    this.relogios = [];
    this.cnpjSelecionado = null,
    this.progressoAtual = 0;
    this.relogioSync = null;
    this.tarefaSync = null;
    this.dataUltimaMensagem = null;
    this.timer = null;
    this.url = null;
    this.onMessageCallback = null;
    this.totalItensSincronizar = 0;
    this.totalItensSincronizados = 0;
    // Controle de reconexão
    this.tentativasReconexao = 0;
    this.maxTentativasReconexao = 3;
    this.atrasoReconectar = 2000;
  }

  validarAutenticacao(cnpjSelecionado, relogio, onMessageCallback) {
    this._configUrl(cnpjSelecionado);
    this._reset();
    const comando = {
      cmd: "sinc",
      idAdmin: (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now()),
      numeroSerie: relogio.numeroSerie,
      numeroCnpj: cnpjSelecionado.numero,
      idTarefa: 0,
      tipo: 'VALIDATE_AUTHENTICATION'
    };
    this._conectarParaValidarAutenticacao(comando, onMessageCallback);    
  }

  sincronizar(cnpjSelecionado, relogios, onMessageCallback) {  
    if(this.sincronizando()) {
      return;
    }
    this._configUrl(cnpjSelecionado);
    this._reset();
    this.cnpjSelecionado = cnpjSelecionado;
    this.relogios = relogios;
    this.onMessageCallback = onMessageCallback;
    this.tentativasReconexao = 0;

    // Total de itens
    this.relogios.forEach(r => {
        this.totalItensSincronizar += r.tarefas.length;
    });
    this._conectar();   
  }

  _configUrl(cnpjSelecionado) {
    let token = JSON.parse(sessionStorage.getItem(CHVAE_TOKEN));
    this.url = process.env.VUE_APP_SERVICO_WEB_SOCKET + `?tk=${token.valor}&og=adm&cnpj=${cnpjSelecionado.numero}`;
    return 
  }

  sincronizando() {
    return (this.ws && this.ws.readyState === WebSocket.OPEN);
  }

  setOnMessageCallback(callback) {
    this.onMessageCallback = callback;
    return {
      status: 'sinc',
      numeroSerie: this.relogioSync.numeroSerie,
      idCnpjSelecionado: this.cnpjSelecionado.id,
      progresso: this.progressoAtual      
    }
  }

  _conectar() {
    // Conectando
    this.ws = new WebSocket(this.url);  

    this.ws.onopen = () => {
      
      this.idSessaoAdmin = (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now());
      
      //this._iniciarTimer();  
    
      if (this._proximaTarefa()) {
        this._atualizarStatus({ status: 'sinc', numeroSerie: this.relogioSync.numeroSerie, mensagem: 'Conectado', progresso: 0 });
      } else {
        this._fechar(); 
        this._atualizarStatus({ status: 'desconectado', mensagem: 'Nenhuma tarefa para sincronizar' }); 
      }
      
    };   

    this.ws.onmessage = (event) => {      
      this.dataUltimaMensagem = new Date();
      //this._iniciarTimer();
      try {
        let resposta = JSON.parse(event.data);       

        if (resposta.status === "erro") { 
          this._atualizarStatus(resposta);           
          this._fechar();
          return;
        }

        if (resposta.status === "sinc") {
          this._atualizarStatus({ status: 'sinc', numeroSerie: this.relogioSync.numeroSerie, mensagem: 'Sincronizando', progresso: this._calcularProgresso() });  
          this._continuarSincronizandoTarefaAtual();
          return;
        }

        this._removerTarefaDoRelogio(resposta.numeroSerie, this.tarefaSync.id);

        const progresso = this._calcularProgresso();
      
        this.progressoAtual = progresso;
        resposta['progresso'] = progresso;     

        if (!this._proximaTarefa()) {
          // Finalizou
          resposta.status = "sincronizado";         
          this._fechar();                    
        }

        this._atualizarStatus(resposta);

      } catch (e) {
        console.error("[WS] Erro ao processar mensagem", e);       
        this._fechar();
        this._atualizarStatus({ status: 'desconectado', mensagem: 'Erro ao processar mensagem recebida do servidor' }); 
      }
    };    

    this.ws.onerror = (err) => {
      console.error("[WS] Erro de conexão:", err);
      this._fechar();
      this._atualizarStatus({ status: 'desconectado', mensagem: 'Erro de conexão' }); 
    };

    this.ws.onclose = (event) => {
      //this._pararTimer();     
      if(event.reason) {
        this._atualizarStatus({ status: 'desconectado', mensagem: event.reason });   
      }      
    };
  }

  _conectarParaValidarAutenticacao(comando, onMessageCallback) {   
    this.ws = new WebSocket(this.url);  
    this.ws.onopen = () => {
      this._enviarComando(comando);         
    };
    let recebeuMensagem = false;
    this.ws.onmessage = () => { 
      recebeuMensagem = true;
      onMessageCallback();
      this._fechar();
    }; 
    setTimeout(() => {
      if(!recebeuMensagem) {
        onMessageCallback();
        this._fechar();
      }
    }, 10000);
  }

  _atualizarStatus(resposta) {
    if (this.onMessageCallback && window.location.pathname === '/cadastros/dispositivos-coletas/monitoramento-push') {     
      this.onMessageCallback(resposta);
    } else {
      this.onMessageCallback = null;
    }
  }

  _calcularProgresso() { 
    const sincronizados = Number(this.totalItensSincronizados) || 0;
    const total = Number(this.totalItensSincronizar) || 0;
    if (total === 0) {
      return 100;
    }
    const raw = (sincronizados / total) * 100;
    let perc = Math.round(raw);
    if (!Number.isFinite(perc)) perc = 0;
    perc = Math.max(0, Math.min(100, perc));
    return perc;
  }  

  _enviarComando(cmdObj) {   
    setTimeout(() => {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {     
        this.ws.send(JSON.stringify(cmdObj));       
      } else {
        console.error("[WS] Conexão não está aberta");
      }
    }, 1500);
  }

  _continuarSincronizandoTarefaAtual() {
    this._enviarComando(this._criarComando());
  }

  _proximaTarefa() {    
    this.relogioSync = this.relogios.find(r => r.tarefas && r.tarefas.length > 0);
    if (!this.relogioSync) {
      return false;
    }
    this.tarefaSync = this.relogioSync.tarefas[0];
    if (!this.tarefaSync) {
      return this._proximaTarefa();
    }
    this._enviarComando(this._criarComando());
    return true;
  }

  _removerTarefaDoRelogio(numeroSerie, idTarefa) {
    const rel = this.relogios.find(r => r.numeroSerie === numeroSerie);
    if (rel) {
      rel.tarefas = rel.tarefas.filter(t => t.id !== idTarefa);
    }
    this.totalItensSincronizados++;
  }

  _criarComando() {
    return {
      cmd: "sinc",
      idAdmin: this.idSessaoAdmin,
      numeroSerie: this.relogioSync.numeroSerie,
      numeroCnpj: this.cnpjSelecionado.numero,
      idTarefa: this.tarefaSync.id,
      tipo: this.tarefaSync.tipo
    };
  }  

  // _iniciarTimer() {
  //   this._pararTimer();
  //   this.timer = setTimeout(() => {
  //     const diffEmMilissegundos = Math.abs((new Date).getTime() - this.dataUltimaMensagem.getTime());
  //     if(diffEmMilissegundos >= 240000) {// 4 minutos sem resposta      
  //       this._fechar();
  //       this._atualizarStatus({ status: 'desconectado', mensagem: 'A conexão com o servidor foi perdida. Sem resposta do servidor.' }); 
  //     } else {
  //       this._iniciarTimer();
  //     }     
  //   }, 5000);
  // }

  // _pararTimer() {
  //   if (this.timer) {
  //     clearTimeout(this.timer);
  //     this.timer = null;
  //   }
  // }

  _reset() {
    this.ws = null;
    this.idSessaoAdmin = null;
    this.relogios = [];
    this.relogioSync = null;
    this.tarefaSync = null;
    this.timer = null;
    this.dataUltimaMensagem = new Date();
    this.onMessageCallback = null;
    this.totalItensSincronizar = 0;
    this.totalItensSincronizados = 0;   
    this.tentativasReconexao = 0;
  }

  _fechar() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
    //this._pararTimer();
  }
}
